


















import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest, KeyValuePair} from '@payroll/optimus-common';
import {FieldType, SearchFieldModel} from "@payroll/search-results-widget/src/models/SearchField.model";
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({
  components: {}
})
export default class MemberDocumentumGrid extends FeedbackComponent {
  @Action('getMemberReports', StoreNamespace.CUSTOMER_SERVICE) getMemberReports: any
  @Action('downloadMemberReport', StoreNamespace.CUSTOMER_SERVICE) downloadMemberReport: any

  @Prop() memberIdNum!: string;
  @Prop() accountList!: KeyValuePair[];
  @Prop() reportTypes!: KeyValuePair[];
  @Prop() dataYearFromList!: KeyValuePair[];


  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []

  mounted() {
    this.initSearchFields()
    this.initColumns()
  }


  private initSearchFields(noDefaultDate?: boolean) {

    this.searchFields = [
      {
        label: 'FindMembersOrEmployers.DocumentumGrid.fromYear',
        property: 'dataYearFrom',
        fieldType: FieldType.SELECT_FIELD,
        selectOptions: this.dataYearFromList,
        selectDisplay: 'description',
        unSelectFirst: true
      }, {
        label: 'FindMembersOrEmployers.DocumentumGrid.reportType',
        property: 'reportType',
        fieldType: FieldType.SELECT_FIELD,
        selectOptions: this.reportTypes,
        selectDisplay: 'description',
        unSelectFirst: true
      }]


    this.searchFields.push({
      label: 'FindMembersOrEmployers.DocumentumGrid.accountNum',
      property: 'accountNumber',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.accountList,
      selectDisplay: 'description',
      unSelectFirst: true
    })
  }

  initColumns() {
    this.columns.push({property: 'accountNum', header: 'FindMembersOrEmployers.DocumentumGrid.accountNum'});
    this.columns.push({property: 'description', header: 'file_desc'})
    this.columns.push({property: 'dataDate', header: 'data_date'})
  }

  searchReports(searchObject: any) {
    searchObject.pageNumber = -1
    searchObject.pageSize = -1
    searchObject.memberIdNum = this.memberIdNum;

    this.getMemberReports({
      requestBody: searchObject as BaseRequest,
      requestorCallback: this
    })
  }

  onSuccess(data?: any, requestName?: any, message?: any) {
    switch (requestName) {
      case 'findMembersOrEmployersFor/getMemberReports':
        this.$emit('successResults', data)
        break
      case 'findMembersOrEmployersFor/downloadMemberReport':
        this.$emit('successExport', data)
    }
  }


  onExportClick(data: any) {
    const reportId: string = data.reportId

    this.downloadMemberReport({
      requestorCallback: this,
      pathVariable: reportId
    })
  }
}


